export const TypeAngles = {
    "Apto Tipo 1 Internos Torre 1": 80,
    "Apto Tipo 1 Externos Torre 1": 20,
    "Apto Tipo 2 Internos Torre 1": 80,
    "Apto Tipo 2 Externos Torre 1": 20,
    "Apto Tipo 3 Externos Torre 1": 20,

    "Apto Tipo 1 Internos Torre 2": 30,
    "Apto Tipo 1 Externos Torre 2": 110,
    "Apto Tipo 2 Internos Torre 2": 30,
    "Apto Tipo 2 Externos Torre 2": 110,
    "Apto Tipo 3 Externos Torre 2": 110,

    "Apto Tipo 1 Internos Torre 3": 0,
    "Apto Tipo 1 Externos Torre 3": 60,
    "Apto Tipo 2 Internos Torre 3": 0,
    "Apto Tipo 2 Externos Torre 3": 60,
    "Apto Tipo 3 Externos Torre 3": 60,
}